import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const DivisionMobile = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-user-select: none;
  background-color: ${themeGet("colors.gradient.dark")};
  &::-webkit-scrollbar {
    display: none;
  }
  a:focus,
  a:hover {
    color: #b9c4c9;
  }
  & > ul {
    flex-direction: row;
    list-style: none;
  }
`;

DivisionMobile.displayName = "DivisionMobile";

export { DivisionMobile };
